// Кешуємо ПРОМІСИ Blob (а не objectURL), щоб не ламати повторні відкриття
const imageBlobCache = new Map<string, Promise<Blob>>();

export async function getProtectedImageBlob(
  key: string, // `${endpoint}/${hash}`
  token: string,
  fetcher: (url: string, token: string) => Promise<Response>,
  setLoading?: (value: boolean) => void,
): Promise<Blob> {
  if (imageBlobCache.has(key)) return imageBlobCache.get(key)!;

  setLoading?.(true);

  const p = (async () => {
    // 1) основний запит
    let resp = await fetcher(key, token);

    // 2) fallback photo <-> document
    if (!resp.ok) {
      const swapped = key.includes('photo')
        ? key.replace('photo', 'document')
        : key.replace('document', 'photo');
      resp = await fetcher(swapped, token);
    }

    const blob = await resp.blob();

    // 3) HEIC/HEIF -> JPEG за потреби
    if (blob.type.includes('heif') || blob.type.includes('heic')) {
      const heic2any = (await import('heic2any')).default as any;
      return (await heic2any({ blob, toType: 'image/jpeg' })) as Blob;
    }

    return blob;
  })();

  imageBlobCache.set(key, p);

  try {
    return await p;
  } catch (e) {
    imageBlobCache.delete(key);
    throw e;
  } finally {
    setLoading?.(false);
  }
}
